import { useState } from "react";
import { useTheme } from "../../../../../components/hooks/useTheme";
import { useNavigate } from "react-router-dom";
import baseURL from "../../../../../configs/api";
import axios from 'axios';
import { Button, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { ExpandMore, KeyboardArrowRight } from "@mui/icons-material";
import PleaseWaitPopup from "../../../../PleaseWaitPopup";
import { validateMin } from "../../../../../utils/validateMin";
import colorConfigs from "../../../../../configs/colorConfigs";
import useAuth from "../../../../../components/hooks/useAuth";
import Cookies from "js-cookie";
import useTenant from "../../../../../components/hooks/useTenant";

export const AddMaintenanceTypes = () => {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { auth }: any = useAuth();
  const { handleTenantError }: any = useTenant();
  const { themeStyles } = useTheme();
  const navigate = useNavigate();
  const [isGeneralSettings, setIsGeneralSetttings] = useState<boolean>(true);
  const [isDefaultSettings, setIsDefaultSettings] = useState<boolean>(true);
  const [maintenanceName, setMaintenanceName] = useState<string>("");
  const [isActive, setIsActive] = useState<string>("No");
  const [isRecurring, setIsRecurring] = useState<string>("No");
  const [defaultTotalInParts, setDefaultTotalInParts] =
    useState<string>("0.00");
  const [defaultTotalInLabor, setDefaultTotalInLabor] =
    useState<string>("0.00");
  const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!pleaseWaitPopup) {
      setPleaseWaitPopup(true);
      axios
        .post(
          `${baseURL}maintenanceType?userId=${auth?.id}`,
          JSON.stringify({
            maintenanceName,
            isActive: isActive === "Yes",
            isRecurring: isRecurring === "Yes",
            defaultTotalInParts,
            defaultTotalInLabor,
          }),
          {
            headers: {
              'X-Tenant-ID': tenantId,
              "Content-Type": "application/json"
            },
            withCredentials: true,
          }
        )
        .then(() => {
          setPleaseWaitPopup(false);
          navigate(-1);
          handleTenantError(null);
        })
        .catch((error) => {
          setPleaseWaitPopup(false);
          handleTenantError(error);
        });
    }
  };

  return (
    <>
      <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
        <div className={`w-full ${themeStyles.main.tailwindMainBg} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
          <div className="w-full mt-2">
            <div className={`w-full pb-4`}>

              <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                <div className="flex items-center gap-1.5">
                  <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Add Maintenance Type</h2>
                </div>
              </div>

              <div className="mt-2 p-2">
                <form onSubmit={(e) => handleSubmit(e)}>
                  <h5
                    className="mb-0 flex items-center cursor-pointer select-none"
                    onClick={() => setIsGeneralSetttings(!isGeneralSettings)}
                  >
                    {isGeneralSettings ? (
                      <ExpandMore sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                    ) : (
                      <KeyboardArrowRight sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                    )}
                    <div className="ml-1" style={{ color: themeStyles.topBar.textColor }}>
                      General Settings
                    </div>
                  </h5>
                  <hr />

                  <div className="w-full px-2">
                    {isGeneralSettings &&
                      <div className="grid grid-cols-3 gap-6">
                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Label</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={maintenanceName}
                              onChange={(e) => setMaintenanceName(e.target.value)}
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Active?</label>
                            <RadioGroup
                              row
                              value={isActive}
                              onChange={(e) => setIsActive(e.target.value)}
                            >
                              <FormControlLabel
                                value="Yes" control=
                                {<Radio
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": {
                                      color: "#167AC3",
                                    },
                                  }}
                                />} label="Yes"
                                sx={{
                                  color: themeStyles.form.labelTextColor
                                }}
                              />
                              <FormControlLabel value="No" control={
                                <Radio
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": {
                                      color: "#167AC3",
                                    },
                                  }}
                                />} label="No"
                                sx={{
                                  color: themeStyles.form.labelTextColor
                                }}
                              />
                            </RadioGroup>
                          </div>
                        </div>

                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Is Recurring?</label>
                            <RadioGroup
                              row
                              value={isRecurring}
                              onChange={(e) => setIsRecurring(e.target.value)}
                            >
                              <FormControlLabel
                                value="Yes" control=
                                {<Radio
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": {
                                      color: "#167AC3",
                                    },
                                  }}
                                />} label="Yes"
                                sx={{
                                  color: themeStyles.form.labelTextColor
                                }}
                              />
                              <FormControlLabel value="No" control={
                                <Radio
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": {
                                      color: "#167AC3",
                                    },
                                  }}
                                />} label="No"
                                sx={{
                                  color: themeStyles.form.labelTextColor
                                }}
                              />
                            </RadioGroup>
                          </div>
                        </div>
                      </div>
                    }
                    <h5
                      className="mb-0 mt-4 flex items-center cursor-pointer select-none"
                      onClick={() => setIsDefaultSettings(!isDefaultSettings)}
                    >
                      {isDefaultSettings ? (
                        <ExpandMore sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      ) : (
                        <KeyboardArrowRight sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      )}
                      <div className="ml-1" style={{ color: themeStyles.topBar.textColor }}>
                        Default Settings
                      </div>
                    </h5>
                    <hr />
                    {isDefaultSettings &&
                      <div className="grid grid-cols-3 gap-6 mt-2">
                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Default Total in Parts</label>
                            <input
                              type="number"
                              min={0}
                              className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={defaultTotalInParts}
                              onChange={(e) => setDefaultTotalInParts(validateMin(e.target.value, 0).toString())}
                              required
                            />
                          </div>
                        </div>

                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Default Total in Labor</label>
                            <input
                              type="number"
                              min={0}
                              className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={defaultTotalInLabor}
                              onChange={(e) => setDefaultTotalInLabor(validateMin(e.target.value, 0).toString())}
                              required
                            />
                          </div>
                        </div>
                      </div>
                    }

                    <div className="flex gap-4 mt-6">
                      <Button variant="contained"
                        sx={{
                          backgroundColor: colorConfigs.btn.main.bg
                        }}
                        type="submit"
                      >
                        Save
                      </Button>

                      <Button variant="contained"
                        sx={{
                          backgroundColor: colorConfigs.btn.cancel.bg,
                          border: colorConfigs.btn.cancel.border,
                          color: colorConfigs.btn.cancel.color
                        }}
                        onClick={() => navigate(-1)}
                      >
                        Cancel
                      </Button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <PleaseWaitPopup pleaseWaitPopup={pleaseWaitPopup} />
    </>
  )
}

